export const ADMIN_EMAIL = "admin@arabellamotorinn.com";
export const ADMIN_PASSWORD = "ArabellaAdmin2026";
export const ADMIN_SESSION_KEY = "arabella_admin_session";

export const DEFAULT_BLOG_CATEGORIES = [
  "Romantic Getaway",
  "Motel Guide",
  "Coastal Stay",
  "Airport Stay",
  "Travel Tips",
];

export const SECONDARY_KEYWORD_OPTIONS = [
  "romantic beach stay",
  "couples getaway",
  "family travel",
  "airport motel",
  "last minute stay",
  "Tweed Heads South, NSW accommodation",
  "Tweed Heads motel",
  "coastal weekend",
  "budget stay",
  "business travel",
];

export const TAG_OPTIONS = [
  "Tweed Heads South, NSW",
  "Couples",
  "Family",
  "Airport stay",
  "Beach",
  "Southport",
  "Kirra Beach",
  "Budget",
  "Weekend",
  "Direct booking",
];
